<div class="ad-header">
  <ad-section-header-default [branding]="branding" [option]="option" [logoUrl]="logoUrl" [rightToolTemplate]="rightToolTemplate">
    <ng-content>
    </ng-content>
  </ad-section-header-default>
</div>
